module.exports = __webpack_public_path__ + "assets/media/1.cefa1be5.wav";